import Button from "devextreme-react/button";
import { useEffect, useState } from "react";
import "./DarkModeToggle.scss";

function applyTheme(dark: boolean) {
	if (dark) {
		document.documentElement.setAttribute("data-theme", "dark");
	} else {
		document.documentElement.removeAttribute("data-theme");
	}
}

export default function DarkModeToggle() {
	const [isDark, setIsDark] = useState(() => {
		const savedMode = localStorage.getItem("darkMode");
		return savedMode === "true";
	});

	useEffect(() => {
		applyTheme(isDark);
	}, [isDark]);

	const toggleDarkMode = () => {
		setIsDark((prev) => {
			const newValue = !prev;
			localStorage.setItem("darkMode", String(newValue));
			return newValue;
		});
	};

	return (
		<Button
			icon={isDark ? "sun" : "moon"}
			stylingMode="text"
			onClick={toggleDarkMode}
			hint={isDark ? "Modo claro" : "Modo oscuro"}
			className="dark-mode-toggle"
		/>
	);
}
